<template>
  <v-row justify="center">
    <v-dialog persistent v-model="dialog" scrollable max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          block
          :loading="loading"
          color="error"
          v-bind="attrs"
          v-on="on"
        >
          Othe Cost Payment
          <v-icon right>
            fas fa-cart-plus
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>{{ Title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-form ref="OtherCostDeposit">
            <v-text-field
              outlined
              readonly
              v-model.trim="Deposit.InvID"
              name="OrderCode"
              label="Order Code"
              id="Orderid"
            ></v-text-field>
            <BaseDate :rules="rules.required" v-model="Deposit.date"></BaseDate>
            <v-select
              outlined
              :items="OtherCostList"
              :rules="[rules.required]"
              v-model="Costs"
              item-value="_id"
              item-text="CostName"
              return-object
              label="Other Cost"
            ></v-select>
            <v-text-field
              v-if="Costs && Costs.CashType"
              outlined
              type="number"
              :label="'Deposit Amount (' + Costs.CashType + ')'"
              :placeholder="'Amount (' + Costs.CashType + ')'"
              v-model.number="Deposit.Amount"
              id="DepositeID"
              :rules="[rules.required]"
            ></v-text-field>
            <p
              v-if="Deposit.Amount"
              class="text--primary font-weight-black text-center"
            >
              (<span class="error--text">{{ Costs.CashType }}</span
              >)
              {{ Number(Deposit.Amount).toLocaleString() }}
              <!-- toLocaleString -->
            </p>
            <v-textarea
              placeholder="Write a details"
              label="Details"
              v-model="Deposit.Details"
              outlined
              rows="2"
              :rules="[rules.required]"
            ></v-textarea>
          </v-form>
          <p
            v-if="msgError"
            class="text--primary font-weight-black text-center"
            v-html="msgError"
          >
            <!-- toLocaleString -->
          </p>
          <!-- <p>{{ Deposit.InvID }}</p> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="clicked" color="blue darken-1" text @click="close"
            >Close</v-btn
          >
          <v-btn
            :loading="clicked"
            color="blue darken-1"
            text
            @click="OnOtherCostDeposit"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    OtherCost: { type: Object, required: true },
    Title: { type: String, required: true },
    BaseURL: { type: String, required: true },
    ReloadFunc: { type: Function, required: true },
  },
  data() {
    return {
      URL: "/supplier/other",
      msgError: null,
      clicked: false,
      loading: false,
      dialog: false,
      OtherCostList: [],
      Costs: {},
      Deposit: {
        Details: null,
        InvID: "",
        Amount: null,
        CashType: null,
        DepositID: null,
        date: "",
      },
      rules: {
        required: value => !!value || "Required.",
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.Deposit.InvID = this.OtherCost._id;
        // this.Costs.CashType = "";
        this.Deposit.date = this.Current().date;
      } else {
        this.Deposit.date = "";
      }
    },
  },
  methods: {
    getReq(url) {
      return this.$store.dispatch("GET_ONLY", url);
    },
    OnOtherCostDeposit() {
      this.msgError = null;
      if (this.$refs.OtherCostDeposit.validate()) {
        this.Deposit.CashType = this.Costs.CashType;
        this.Deposit.DepositID = this.Costs._id;
        this.Deposit.time = this.Current().time;
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.BaseURL,
            data: this.Deposit,
          })
          .then(() => {
            this.clicked = false;
            this.ReloadFunc();
            this.close();
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
    close() {
      this.$refs.OtherCostDeposit.reset();
      this.dialog = false;
      this.msgError = "";
    },
  },
  mounted() {
    this.getReq(this.URL).then(result => {
      this.OtherCostList = result.data;
    });
  },
};
</script>
